import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Box, Tab, Tabs, Tooltip } from '@mui/material';

import { useT } from '../i18n/LanguageContext';

type LanguageTabsProps = {
  /** The tenant's content languages, the default first. */
  languages: Array<string>;
  value: string;
  onChange: (code: string) => void;
  /** Languages to mark as missing a translation. */
  missing: (code: string) => boolean;
};

/** A tab per content language (ADR-0010 §2): the default first and marked, a missing translation flagged. */
export const LanguageTabs = ({ languages, value, onChange, missing }: LanguageTabsProps) => {
  const t = useT();

  return (
    <Tabs
      value={value}
      onChange={(_event, next: string) => onChange(next)}
      variant="scrollable"
      scrollButtons="auto"
      sx={{ minHeight: 36 }}
    >
      {languages.map((code, index) => (
        <Tab
          key={code}
          value={code}
          sx={{ minHeight: 36, py: 0.5 }}
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {index === 0 ? t('languages.defaultTab', { code: code.toUpperCase() }) : code.toUpperCase()}
              {missing(code) ? (
                <Tooltip title={t('languages.missing')}>
                  <WarningAmberIcon fontSize="inherit" color="warning" aria-label={t('languages.missing')} />
                </Tooltip>
              ) : null}
            </Box>
          }
        />
      ))}
    </Tabs>
  );
};
